export var InsuranceDataMapper = function (resp) {
    if (resp) {
        return resp.map(function (item) {
            return {
                Vendor_Name: item.vendor_Name,
                Policy_Number: item.policy_Number,
                Product_Name: item.product_Name,
                Policy_Type: item.policy_Type,
                Policy_Date: item.policy_Date,
                Premium_Annualise: item.premium_Annualise,
                Sum_Insured: item.sum_Insured,
                Next_Renewal_Date: item.next_Renewal_Date,
            };
        });
    }
    return [];
};
